/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-15 17:38:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2023-08-26 18:13:05
 * @FilePath: \baishu_react_ui\src\Login\BsyRadioGroup\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { BsyUtils } from '../../utils/Utils';
import BsyButton from '../BsyButton';
import BsyMsgBubble from '../BsyMsgBubble';
import BsyTextArea from '../BsyTextArea';
import { BsyWidget } from '../BsyWidget';
import './index.css'

class BsySubformTextArea extends BsyWidget {

    static defaultProps = {
        baseCls: "bsy-subform-textarea",
        onStopEdit: null,

        allowBlank: !0,


    }

    constructor(props) {
        super({
            baseCls: "bsy-subform-textarea",
            onStopEdit: null,

            allowBlank: !0,
            ...props
        });

        this.element = React.createRef();
    }

    getValue = () => {
        const { value } = this.state
        return value
    }

    componentDidMount() {
        super.componentDidMount()

    }

    getAddressContext = (context) => {
        this.context = context
    }

    _onTriggerClick = (event) => {
        const { value } = this.state;
        let that = this;
        let isSave = false;
        BsyMsgBubble({
            anchor: event.currentTarget,
            contentHTML: (ref) => {

                return <div className="bsy-subform-textarea" style={{ margin: "10px" }} ><BsyTextArea
                    getContext={that.getAddressContext}
                    width={"auto"}
                    value={value}
                // onStopEdit={(e) => {
                //     that.setState({
                //         value: e,
                //     }, () => {
                //         // BsyUtils.applyFunc(that, that.props.onStopEdit, [e, null, that], !1)
                //         // ref.closeAlter();
                //     })
                // }}
                ></BsyTextArea>
                    <div className='footer' style={{ marginTop: "10px" }}>
                        <BsyButton
                            text={React.language("save")}
                            type={'blue'}
                            click={() => {
                                isSave = true;
                                BsyUtils.applyFunc(that, that.props.onStopEdit, [that.context.getValue(), null, that], !1)
                                ref.closeAlter();
                            }}
                            mode={window.mode}
                        />
                        <BsyButton
                            text={React.language("cancel")}
                            type={'menu-right white '}
                            click={() => {
                                isSave = true;
                                BsyUtils.applyFunc(that, that.props.onStopEdit, [value, null, that], !1)
                                ref.closeAlter();
                            }}
                            mode={window.mode}
                        />
                    </div>
                </div>

            },
            text4Cancel: null,
            text4Ok: null,
            theme: this.props.theme,
            minWidth: 280,
            width: 340,
            contentPadding: 0,
            edge: 200,
            hAdjust: 72,
            topOffset: 34,
            dockPosition: "left",
            onClose: function () {
                if (!isSave) {
                    BsyUtils.applyFunc(that, that.props.onStopEdit, [value, null, that], !1)
                }
                return !1;
            }
        })
    }

    render() {

        const { cssName, format } = this.options

        return (
            <div className={cssName}
                ref={this.element}
                onClick={(e) => {
                    this._onTriggerClick(e)
                }}
            >

            </div>
        );
    }
}

export default BsySubformTextArea;